module.exports = __webpack_public_path__ + "img/huoyue.9ad15aef.png";